import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Card from '../common/Card';
import Loading from '../common/Loading';

const OwnerDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const response = await api.get('/dashboard/owner');
      setStats(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">
        Dashboard User Owner
      </h1>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Card className="bg-gradient-to-r from-green-500 to-green-600 text-white">
          <h3 className="text-lg font-semibold mb-2">Mes User Simples</h3>
          <p className="text-4xl font-bold">{stats?.simples?.total || 0}</p>
          <p className="text-sm mt-2">
            {stats?.simples?.active || 0} actifs / {stats?.simples?.inactive || 0} inactifs
          </p>
        </Card>

        <Card className="bg-gradient-to-r from-blue-500 to-blue-600 text-white">
          <h3 className="text-lg font-semibold mb-2">Mes Associations</h3>
          <p className="text-4xl font-bold">{stats?.associationsCount || 0}</p>
          <p className="text-sm mt-2">
            {stats?.associationsActive || 0} actives
          </p>
        </Card>

        <Card className="bg-gradient-to-r from-purple-500 to-purple-600 text-white">
          <h3 className="text-lg font-semibold mb-2">Activités récentes</h3>
          <p className="text-4xl font-bold">
            {stats?.myRecentActivity?.length || 0}
          </p>
          <p className="text-sm mt-2">Actions effectuées</p>
        </Card>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <Card className="hover:shadow-lg transition cursor-pointer" onClick={() => navigate('/my-associations')}>
          <div className="flex items-center space-x-4">
            <div className="text-5xl">🔗</div>
            <div>
              <h3 className="text-xl font-bold text-gray-800">Mes Associations</h3>
              <p className="text-gray-600">Gérer mes associations Sensor ↔ Switch</p>
            </div>
          </div>
        </Card>

        <Card className="hover:shadow-lg transition cursor-pointer" onClick={() => navigate('/my-simples')}>
          <div className="flex items-center space-x-4">
            <div className="text-5xl">🧑</div>
            <div>
              <h3 className="text-xl font-bold text-gray-800">Mes User Simples</h3>
              <p className="text-gray-600">Gérer mes utilisateurs simples</p>
            </div>
          </div>
        </Card>
      </div>

      {/* Mon activité récente */}
      <Card title="Mon activité récente" className="mb-6">
        {stats?.myRecentActivity?.length > 0 ? (
          <div className="space-y-3">
            {stats.myRecentActivity.slice(0, 5).map((log) => (
              <div
                key={log._id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="font-semibold text-gray-800">{log.action}</p>
                  <p className="text-sm text-gray-600">{log.details}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-500">
                    {new Date(log.createdAt).toLocaleDateString('fr-FR')}
                  </p>
                  <p className="text-xs text-gray-400">
                    {new Date(log.createdAt).toLocaleTimeString('fr-FR')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-4">
            Aucune activité récente
          </p>
        )}
      </Card>

      {/* Activité de mes simples */}
      <Card title="Activité de mes user_simples">
        {stats?.simplesRecentActivity?.length > 0 ? (
          <div className="space-y-3">
            {stats.simplesRecentActivity.slice(0, 5).map((log) => (
              <div
                key={log._id}
                className="flex items-center justify-between p-3 bg-blue-50 rounded-lg"
              >
                <div>
                  <p className="font-semibold text-gray-800">{log.actorName}</p>
                  <p className="text-sm text-gray-600">{log.details}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-500">
                    {new Date(log.createdAt).toLocaleDateString('fr-FR')}
                  </p>
                  <p className="text-xs text-gray-400">
                    {new Date(log.createdAt).toLocaleTimeString('fr-FR')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-4">
            Aucune activité de vos simples
          </p>
        )}
      </Card>
    </div>
  );
};

export default OwnerDashboard;